import {
  ActionCard,
  Box,
  BoxProps,
  CurrencyValue,
  Flex,
  LinkWrapper,
  WalletAddress
} from '@blockanalitica/ui';
import { Link } from 'react-router';
import styled from 'styled-components';

const KpiTitle = styled(Box)<BoxProps>`
  font-size: ${(props) => props.theme.sizes[-1]};
  font-weight: 600;
  color: ${(props) => props.theme.colors.muted};
  white-space: nowrap;
`;

export default function WalletHeading({
  walletAddress,
  totalSupply,
  totalBorrow,
  healthRate,
  network
}: {
  walletAddress: string;
  totalSupply: string | null;
  totalBorrow: string | null;
  healthRate: string | null;
  network: string;
}) {
  return (
    <Flex
      flexDirection={['column', 'row']}
      gap={['m', 'xs']}
      justifyContent="space-between">
      <WalletAddress
        gap="s"
        options={{
          showCopyBtn: true,
          showEthScanLink: false,
          showDebankLink: true,
          showZapperLink: true,
          sizes: {
            icon: '8',
            walletAddressHeader: '4'
          },
          network: network
        }}
        address={walletAddress}
      />

      <LinkWrapper
        to={`/wallets/${walletAddress}`}
        // @ts-ignore
        as={Link}>
        <ActionCard fontSize="2">
          <Flex flexDirection="column">
            <KpiTitle>Total Supply</KpiTitle>
            <CurrencyValue value={totalSupply} options={{ currency: 'USD' }} />
          </Flex>
          <Flex flexDirection="column">
            <KpiTitle>Total Borrow</KpiTitle>
            <CurrencyValue value={totalBorrow} options={{ currency: 'USD' }} />
          </Flex>
          <Flex flexDirection="column">
            <KpiTitle>Health Rate</KpiTitle>
            <CurrencyValue value={healthRate} />
          </Flex>
        </ActionCard>
      </LinkWrapper>
    </Flex>
  );
}
